import React, { useState } from "react"
import { Box, Button, Typography } from "@mui/material"
import Axios from "../../Util/Axios"
import { updateToastData } from "../../slices/toastSlice"
import { TOAST_SEVERITY_ERROR } from "../../components/core/Toast/Toast"
import { useDispatch } from "react-redux"
import Tooltip from "@mui/material/Tooltip"

const CustomOrderButton = ({
  orderData,
  setOrderData,
  requiresApproval,
  customerFacingId,
  isStaff,
}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  let tooltipContent = ""
  if (
    ["deposit_received_and_in_progress", "awaiting_confirmation"].includes(
      orderData?.status
    )
  ) {
    return <React.Fragment />
  }
  let buttonText = ""
  let color = ""

  let onClick = () => {}

  let missingAddress =
    !orderData?.address.email ||
    !orderData?.address.first_name ||
    !orderData?.address.phone
  let disabled =
    !orderData || loading || missingAddress || orderData?.balance <= 0

  if (orderData?.status === "ready_for_pickup") {
    buttonText = "Pay Balance"
    color = "primary"
    onClick = () => {
      setLoading(true)
      Axios.post(
        `/api/order-detail/${customerFacingId}/action_create_order_balance_payment_session/`
      )
        .then(({ data }) => {
          window.open(data.url, "_self")
        })
        .catch((e) => {
          setLoading(false)
        })
    }
  } else if (
    orderData?.status === "confirmed" ||
    !requiresApproval ||
    orderData?.locked
  ) {
    buttonText = "Pay Deposit"
    color = "primary"
    onClick = () => {
      setLoading(true)
      Axios.post(
        `/api/order-detail/${customerFacingId}/action_create_order_deposit_payment_session/`
      )
        .then(({ data }) => {
          window.open(data.url, "_self")
        })
        .catch((e) => {
          setLoading(false)
        })
    }
  } else if (isStaff) {
    buttonText = "Approve"
    color = "secondary"

    if (missingAddress) {
      tooltipContent = "Missing contact info"
    }

    onClick = () => {
      setLoading(true)
      Axios.post(`/api/staff-order-detail/${customerFacingId}/action_approve/`)
        .then(({ data }) => {
          setLoading(false)
          setOrderData(data)
          document.documentElement.scrollTop = 0
          document.scrollingElement.scrollTop = 0
        })
        .catch(() => {
          setLoading(false)
          dispatch(
            updateToastData({
              message: "Failed to approve",
              severity: TOAST_SEVERITY_ERROR,
            })
          )
        })
    }
  } else {
    buttonText = "Submit for Approval"
    color = "secondary"

    if (missingAddress) {
      tooltipContent = "Missing contact info"
    }

    if (
      !orderData?.comment?.text &&
      !orderData?.comment?.message_attachments.length
    ) {
      disabled = true
      if (!tooltipContent) {
        tooltipContent = "Please add a comment before submitting for approval"
      }
    }

    onClick = () => {
      setLoading(true)
      Axios.post(
        `/api/order-detail/${customerFacingId}/action_submit_for_approval/`
      )
        .then(({ data }) => {
          setLoading(false)
          setOrderData(data)
          document.documentElement.scrollTop = 0
          document.scrollingElement.scrollTop = 0
        })
        .catch(() => {
          setLoading(false)
          dispatch(
            updateToastData({
              message: "Failed to submit for approval",
              severity: TOAST_SEVERITY_ERROR,
            })
          )
        })
    }
  }

  return (
    <Tooltip title={tooltipContent}>
      <span>
        <Button
          variant="contained"
          disabled={disabled}
          fullWidth
          onClick={onClick}
          sx={{
            py: 1.5,
            backgroundColor: "#c8b99a",
            color: "#0d1b2a",
            fontFamily: "'Josefin Sans', sans-serif",
            fontWeight: 600,
            fontSize: "0.85rem",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            borderRadius: 0,
            "&:hover": {
              backgroundColor: "#d4c7a8",
            },
            "&.Mui-disabled": {
              backgroundColor: "rgba(200,185,154,0.3)",
              color: "rgba(13,27,42,0.5)",
            },
          }}
        >
          {buttonText}
        </Button>
      </span>
    </Tooltip>
  )
}
export default CustomOrderButton
